import { CustomDesktopModalSize, MobileModalSize, type ModalSize } from '../../../utils/modalSize';
import { InstallmentPaymentMethod } from '../../../types/InstallmentPaymentMethod';
import { type DeviceType } from '../../../types/DeviceType';

export const AFFIRM_MODAL_SIZE: Record<DeviceType, ModalSize> = {
  desktop: CustomDesktopModalSize[InstallmentPaymentMethod.Affirm],
  mobile: MobileModalSize,
};
